import { useNavigate } from 'react-router-dom';

import { Avatar } from '@components/avatar';
import { IconChevronRightSmall } from '@components/icons/chevron-right-small';
import { IconSignout } from '@components/icons/signout';
import { Menu } from '@components/menu';
import { Nav } from '@components/nav';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { ThemeToggle } from '@components/theme-provider';
import { useScopedTranslate } from '@locale/translate';

import { useCurrentUser, useLogout } from 'api/authentication/hooks';

import { routePaths } from '../ui/authenticated/navigation';

export const UserMenu = () => {
  const { t } = useScopedTranslate(locale);
  const user = useCurrentUser();
  const logout = useLogout();
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  return (
    <Nav.Menu
      icon={<Avatar size="md" color="purple" name={user.name} src={user.picture} />}
      iconRight={<IconChevronRightSmall />}
      label={user.name}
    >
      <Nav.MenuItem
        onSelect={() => navigate(routePaths.settingsProfile)}
        label={
          <Stack space={2} orientation="horizontal" align="center">
            <Avatar color="purple" name={user.name} src={user.picture} />
            <div style={{ minWidth: 0 }}>
              <Text font="semibold14" text={user.name} ellipsis />
            </div>
          </Stack>
        }
      />
      <Menu.Separator />
      <ThemeToggle />
      <Menu.Separator />

      <Nav.MenuItem onSelect={() => logout.mutate()} icon={<IconSignout />} label={t('signout')} />
    </Nav.Menu>
  );
};

const locale = {
  en: {
    signout: 'Sign out',
  },
};
